import {
  CalendarDaysIcon,
  CheckIcon,
  ExclamationTriangleIcon,
  PlusIcon,
  TrashIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import { ArrowCircleRightSharp } from "@mui/icons-material";

// Icons depending on action
export const historyActionTypes = {
  "create": { icon: PlusIcon, bgColorClass: "bg-green-400" },
  "update": { icon: CheckIcon, bgColorClass: "bg-blue-400" },
  "destroy": { icon: TrashIcon, bgColorClass: "bg-red-400" },
  "status_update": { icon: CheckIcon, bgColorClass: "bg-yellow-400" },
  "link_work_order": { icon: CheckIcon, bgColorClass: "bg-indigo-400" },
  "unlink_work_order": { icon: XCircleIcon, bgColorClass: "bg-gray-400" },
  "sync_from_work_order": { icon: ArrowCircleRightSharp, bgColorClass: "bg-blue-400" },
  "send_notification": { icon: CheckIcon, bgColorClass: "bg-emerald-400" },
  "process": { icon: CheckIcon, bgColorClass: "bg-purple-400" },
  "update_after_process": { icon: ExclamationTriangleIcon, bgColorClass: "bg-yellow-400" },
  "new_agreement": { icon: CalendarDaysIcon, bgColorClass: "bg-pink-400" },
  "sync_error": {
    icon: ExclamationTriangleIcon,
    bgColorClass: "bg-red-400",
  },
  "sync_api": { icon: ArrowCircleRightSharp, bgColorClass: "bg-blue-400" },
  "tripletex_sync_attempt": {
    icon: ArrowCircleRightSharp,
    bgColorClass: "bg-sky-400",
  },
  "tripletex_sync": { icon: CheckIcon, bgColorClass: "bg-emerald-500" },
  "tripletex_sync_skipped": {
    icon: ExclamationTriangleIcon,
    bgColorClass: "bg-amber-500",
  },
};

export const historyControllers = {
  "user": "users",
  "report": "rapport",
  "order": "ordre",
  "tripletex_api": "- Tripletex API",
};

export const historyActions = {
  "processed": "behandlet",
  "process": "behandlet",
  "update": "oppdatert",
  "status_update": "oppdatert status på",
  "link_work_order": "knyttet arbeidsordre til",
  "unlink_work_order": "fjernet arbeidsordre fra",
  "sync_from_work_order": "synkronisert fra arbeidsordre for",
  "send_notification": "sendt varsel om",
  "update_after_process": "oppdatert etter behandling",
  "create": "opprettet",
  "destroy": "fjernet",
  "new_agreement": "updated date agreement for",
  "new_message": "sendt en SMS",
  "answer": "mottatt svar fra kunde",
  "update_product": "updated",
  "sync_error":
    "prøvd å synkronisere ordre, men det skjedde et Synkroniseringsfeil",
  "sync_success": "Utført synkronisering og det var vellykket",
  "sync_api": "utført synkronisering av",
  "tripletex_sync_attempt": "Tripletex-synk forsøkt for",
  "tripletex_sync": "Tripletex-synk fullført for",
  "tripletex_sync_skipped": "Tripletex-synk hoppet over for",
};
